import request from "../utils/request";
/**
 * 获取当前权益下载剩余数量
 * @param {*} param0
 * @returns {Promise<{right_code: string,is_finite_quantity: boolean, quantity: number, usage: number,left: number }[]>}
 */
export async function getUserRightCount(data) {
  return request({
    method: "post",
    url: "/biz/user-rights/inspect",
    data: data,
    cache: {
      time: 10000,
    },
  });
}
/**
 * 获取下载前信息
 * @param {{
 *  material_id: number;
 *  type?: string|number; // 下载类型 1: 图片原图，2: 图片大图 3：视频 4：平面模板  5:免扣  6: 视频模板
 *  download_type?: string | number; // 下载方式 下载方式 1: 会员身份下载 2: 单购下载
 *  vip_cert_subject_id: number; // 授权主体id
 * }} param
 * @returns {Promise<PreDownLoadRes & {err: number|string}>}
 */
export async function getPreDownloadInfo({
  material_id,
  download_type,
  type,
  vip_cert_subject_id,
}) {
  return request({
    method: "post",
    url: `/biz/materials/${material_id}/pre-download`,
    data: {
      download_type,
      type,
      vip_cert_subject_id,
    },
  });
}
/**
 * 获取下载链接
 * https://yapi.gaoding.com/project/1717/interface/api/121934
 * @param {*} param
 * @returns
 */
export async function getDownloadInfo({ material_id, ...data }) {
  return request({
    method: "post",
    url: `/biz/materials/${material_id}/download`,
    data: {
      ...data,
      // 模拟异步下载
      fake_download:
        typeof window !== "undefined"
          ? location.search.includes("fake_download")
          : false,
    },
  });
}

/**
 * 获取下载链接( 拍信异步下载使用 )
 * @param {{
 *  material_id: number;
 *  type?: string | number; // 下载类型 1: 图片原图，2: 图片大图 3：视频 4：平面模板  5:免扣  6: 视频模板
 *  download_type?: string | number; // 下载方式 下载方式 1: 会员身份下载 2: 单购下载
 *  filename?: string; // 文件名
 *  system_code?: number;
 * }} param
 * @returns {Promise<{url: string, state: string}>}
 * @see https://yapi.gaoding.com/project/1717/interface/api/171785
 */
export async function getDownloadUrl({ material_id, ...data }) {
  return request({
    method: "post",
    url: `/biz/materials/${material_id}/origin_url`,
    data,
  });
}
